import { GetterTree } from 'vuex'

import { RootState, NoticeState } from '@/types/store'

export const getters: GetterTree<NoticeState, RootState> = {
  notice(state): NoticeState['notice'] {
    return state.notice
  },
  notices(state): NoticeState['notices'] {
    return state.notices
  },
  isNoticesLoading(state): NoticeState['isNoticesLoading'] {
    return state.isNoticesLoading
  },
}
